module.exports = __webpack_public_path__ + "static/media/26.1d8a6874.png";